var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.636 4.87868C14.245 5.26971 14.245 5.90186 14.636 6.29289C15.0271 6.68392 15.6592 6.68392 16.0503 6.29289C16.4413 5.90186 16.4413 5.26971 16.0503 4.87868C15.6592 4.48765 15.0271 4.48765 14.636 4.87868Z",
    stroke: "#00E2D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4645 3.46447C19.4175 5.4175 19.4175 8.5825 17.4645 10.5355C16.0156 11.9844 13.8999 12.3535 12.106 11.6513L9.68629 14.0711H8.27208V15.4853H6.85786V16.8995H4.02944V14.0711L9.27758 8.82292C8.57543 7.02899 8.94454 4.91333 10.3934 3.46447C12.3464 1.51144 15.5114 1.51144 17.4645 3.46447Z",
    stroke: "#00E2D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysActiveIcon);
export default __webpack_public_path__ + "static/media/keysActiveIcon.a39aca3a04a358600012d4afab88557f.svg";
export { ForwardRef as ReactComponent };